import { BugDeviceInfo } from '@/types/database';

export function getDeviceContext(): BugDeviceInfo {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return {
      browser: 'Node / Test Environment',
      os: typeof process !== 'undefined' ? process.platform : 'Unknown OS',
      device_type: 'desktop',
      app_version: '1.0.0',
      pwa_mode: false,
      online_status: true,
    };
  }

  const ua = navigator.userAgent;

  // Detect browser
  let browser = 'Unknown Browser';
  if (ua.includes('Firefox/')) {
    browser = `Firefox ${ua.split('Firefox/')[1]?.split(' ')[0] || ''}`.trim();
  } else if (ua.includes('Edg/')) {
    browser = `Edge ${ua.split('Edg/')[1]?.split(' ')[0] || ''}`.trim();
  } else if (ua.includes('Chrome/')) {
    browser = `Chrome ${ua.split('Chrome/')[1]?.split(' ')[0] || ''}`.trim();
  } else if (ua.includes('Safari/') && !ua.includes('Chrome')) {
    browser = `Safari ${ua.split('Version/')[1]?.split(' ')[0] || ''}`.trim();
  }

  // Detect OS
  let os = 'Unknown OS';
  if (ua.includes('Windows NT 10.0')) os = 'Windows 10/11';
  else if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';
  else if (ua.includes('Macintosh') || ua.includes('Mac OS X')) os = 'macOS';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('Linux')) os = 'Linux';

  // Screen and Viewport
  const screen_resolution = typeof window.screen !== 'undefined' ? `${window.screen.width}x${window.screen.height}` : undefined;
  const viewport = `${window.innerWidth}x${window.innerHeight}`;

  // Device Type
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const isTablet = /(iPad|Tablet|(Android(?!.*Mobile)))/i.test(ua);
  const device_type: 'desktop' | 'mobile' | 'tablet' = isTablet ? 'tablet' : isMobile ? 'mobile' : 'desktop';

  // PWA mode
  const pwa_mode = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;

  return {
    browser,
    os,
    viewport,
    screen_resolution,
    device_type,
    pwa_mode,
    app_version: '1.0.0',
    online_status: navigator.onLine,
    user_agent: ua.slice(0, 200),
  };
}

/**
 * Extracts route entity type and id from URL path.
 * e.g. /cycles/89d2... -> entity_type: 'production_cycle', entity_id: '89d2...'
 */
export function extractRouteContext(pathname: string): { entity_type?: string; entity_id?: string } {
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return {};

  const first = parts[0];
  let entity_type: string | undefined;
  if (first === 'cycles') entity_type = 'production_cycle';
  else if (first === 'feed') entity_type = 'feed';
  else if (first === 'sales') entity_type = 'pig_sales';
  else if (first === 'settlements') entity_type = 'settlement';
  else if (first === 'documents') entity_type = 'document';
  else if (first === 'admin') entity_type = parts[1] ? `admin_${parts[1]}` : 'admin';

  // UUID pattern or numeric id
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const idPart = parts.find((p) => uuidRegex.test(p));

  return {
    entity_type,
    entity_id: idPart,
  };
}
